import { ClientBooking, ClientCampaign } from '@round/api';
import { calculateBookingsTotals } from '../../booking/helpers';

export type CampaignListRow = ClientCampaign & {
    bookings: ClientBooking[];
};

export function calculateCampaignBookingsTotals(bookings: ClientBooking[]) {
    const formatPostDate = (date: Date) => {
        return date.toLocaleString('en-GB', {
            day: 'numeric',
            month: 'short',
            year: 'numeric',
        });
    };

    const { selectedPlatforms, totalCreators, totalCost } = calculateBookingsTotals(bookings);

    const brief = bookings.find((booking) => booking.brief)?.brief || null;

    const allBookingsPosted = bookings.every((booking) => booking.posted_at !== null && booking.posted_at !== 0);

    const postedAtTimes = bookings
        .map((booking) => booking.posted_at)
        .filter((time) => typeof time === 'number' && time > 0);

    const firstPost = postedAtTimes.length ? formatPostDate(new Date(Math.min(...postedAtTimes) * 1000)) : '-';

    const lastPost =
        postedAtTimes.length && allBookingsPosted ? formatPostDate(new Date(Math.max(...postedAtTimes) * 1000)) : '-';

    return { selectedPlatforms, totalCreators, totalCost, brief, firstPost, lastPost };
}

export function mapCampaignsToRows(campaigns: ClientCampaign[], bookings: ClientBooking[]): CampaignListRow[] {
    return campaigns.map((campaign) => {
        const bookingsForCampaign = bookings.filter((booking) => booking.campaign_id === campaign.id);
        return {
            ...campaign,
            bookings: bookingsForCampaign,
        };
    });
}
